module.exports = __webpack_public_path__ + "static/media/mickey3_letterbox2.ac7fb91b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mickey3_letterbox2.png
// module id = 163
// module chunks = 0